import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from "react";
import { onAuthChange } from "../services/authService";

// Create the context
const AuthContext = createContext(null);

// ── Wrap your entire app with this ────────────────────────────
// It keeps track of who is logged in across every page
// Admin stays logged in even after refreshing the browser
export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Firebase listens for login/logout automatically
    const unsubscribe = onAuthChange((currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    // Stop listening when component unmounts
    return () => unsubscribe();
  }, []);

  const value = {
    user,
    loading,
    isLoggedIn: !!user, // true if logged in, false if not
  };

  // Don't render anything until Firebase confirms auth state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-indigo-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-3"></div>
          <p className="text-indigo-600 font-medium text-sm">Loading 1464 Country Cleaners...</p>
        </div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

// ── Use this in any component to check login state ────────────
// Example: const { user, isLoggedIn } = useAuth();
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used inside AuthProvider");
  }
  return context;
}